<div>
  @if (row()) {
    @if (row()!.statusName === approved) {
      <span
        ap-tooltip
        direction="top"
        [tooltipContent]="row()?.statusName"
        class="ap-font-16 Appkit4-icon icon-circle-checkmark-fill text-success"></span>
    } @else if (row()!.statusName === pendingApproval) {
      <span
        ap-tooltip
        direction="top"
        [tooltipContent]="row()?.statusName"
        class="ap-font-16 Appkit4-icon icon-wait-fill text-warning"></span>
    } @else if (row()!.statusName === informationRequired) {
      <span
        ap-tooltip
        direction="top"
        [tooltipContent]="row()?.statusName"
        class="ap-font-16 Appkit4-icon icon-help-question-fill ap-text-primary-orange-05"></span>
    } @else {
      <span></span>
    }
  }
</div>
